import { Flex, HStack, Button, Box, Text } from '@chakra-ui/react';
import { capitalize } from 'lodash';
import moment from 'moment';
import { GoDot, GoDotFill } from 'react-icons/go';
import { useRouter } from 'next/router';

const TripCard = ({ item }) => {
  const router = useRouter();

  const StatusHandler = (item: string) => {
    const words = item.split('_');
    const formattedStatus = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return formattedStatus;
  };

  return (
    <Flex
      direction={'column'}
      borderWidth={1}
      minW={540}
      maxW={600}
      backgroundColor={'white'}
      p={3}
      rounded={'md'}
      shadow={'sm'}
    >
      <Flex direction={'row'} justify={'space-between'}>
        <Box>
          <Text m={0} fontSize={14}>
            #{item.id}
          </Text>
          <Text m={0} fontSize={14}>
            Vert ID: {item.booking_id}
          </Text>
          {item.business_booking_id && (
            <Text m={0} fontSize={14}>
              {item.business_booking_id}
            </Text>
          )}
        </Box>
        <Box>
          <Text m={0} fontSize={14} textAlign={'right'}>
            {item.schedule_date
              ? moment(item.schedule_date).format('DD MMM YYYY HH:mm')
              : moment(item.created_date).format('DD MMM YYYY')}
          </Text>
          <Text m={0} fontSize={14} textAlign={'right'}>
            {capitalize(StatusHandler(item.status))}
          </Text>
        </Box>
      </Flex>
      <Flex mt={10}>
        <Flex
          direction={'column'}
          justify={'space-between'}
          alignItems={'center'}
        >
          <GoDot size={25} />
          <Box h={'50%'} w={'0.8px'} backgroundColor={'#0b0b0b'} />
          <GoDotFill size={25} />
        </Flex>
        <Flex direction={'column'} justify={'space-between'}>
          <Text m={0} fontSize={14}>
            {item.origin.formatted_address}
          </Text>

          <Text m={0} fontSize={14}>
            {item.is_hourly
              ? item.estimated_time / 60 / 60 + ' Hours'
              : item.destination.formatted_address}
          </Text>
        </Flex>
      </Flex>
      <Flex justify={'space-between'} mt={3} alignItems={'center'}>
        <Text m={0} fontSize={14}>
          {`Paid with ${capitalize(item.fare?.payment_method)}`}
        </Text>
        <HStack spacing={3} justify={'right'}>
          {item.status !== 'started' &&
            item.status !== 'arrived' &&
            item.status !== 'in progress' &&
            item.status !== 'scheduled' &&
            item.status !== 'scheduled_accepted' && (
              <Button
                name="help"
                shadow={'md'}
                _hover={{
                  opacity: 0.7,
                }}
                size={'sm'}
                fontWeight={'medium'}
                onClick={() =>
                  router.push('https://zfrmz.com/qIcJ86IVZiXz0ZijbOn9')
                }
              >
                Help
              </Button>
            )}
          <Button
            name="view"
            backgroundColor={'brand.900'}
            shadow={'md'}
            color={'white'}
            _hover={{
              opacity: 0.7,
            }}
            size={'sm'}
            fontWeight={'medium'}
            onClick={() => router.push(`/app/trips/${item.id}`)}
          >
            View Details
          </Button>
        </HStack>
      </Flex>
    </Flex>
  );
};

export default TripCard;
